import type { Item } from '@inno-sdks/files'

import { MY_BILLS_SHORTCUT, isMyBillsShortcut } from './myBillsShortcut'
import { NEED_HELP_SHORTCUT, isNeedHelpShortcut } from './needHelpShortcut'
import {
  NEW_GRANT_APPLICATION_SHORTCUT,
  isNewGrantApplicationShortcut
} from './newGrantApplicationShortcut'
import type { SystemShortcutDefinition } from './systemShortcut.types'

const SYSTEM_SHORTCUTS: readonly SystemShortcutDefinition[] = [
  {
    ...NEED_HELP_SHORTCUT,
    matches: isNeedHelpShortcut
  },
  {
    ...NEW_GRANT_APPLICATION_SHORTCUT,
    matches: isNewGrantApplicationShortcut
  },
  {
    ...MY_BILLS_SHORTCUT,
    matches: isMyBillsShortcut
  }
]

export const getSystemShortcutDefinition = (
  item: Item
): SystemShortcutDefinition | undefined =>
  SYSTEM_SHORTCUTS.find(definition => definition.matches(item))

export const getSystemShortcutDeepLink = (
  value: string
): SystemShortcutDefinition | undefined =>
  SYSTEM_SHORTCUTS.find(definition => definition.deepLink?.matches(value))

type ShortcutNameTranslator = (
  key: 'need_help' | 'new_grant_application' | 'my_bills'
) => string

export const getSystemShortcutDisplayName = (
  item: Item,
  fallback: string,
  translate: ShortcutNameTranslator
): string => {
  const definition = getSystemShortcutDefinition(item)

  if (
    definition?.displayNameKey === 'need_help' ||
    definition?.displayNameKey === 'new_grant_application' ||
    definition?.displayNameKey === 'my_bills'
  ) {
    return translate(definition.displayNameKey)
  }

  return fallback
}
